{
  "languages": {
    "en": "English",
    "es": "Español",
    "it": "Italiano"
  },
  "labels": {
    "language": "Language",
    "search": "Search",
    "share": "Share",
    "sharing": "Sharing",
    "share-with-datasources": "Share Datasources",
    "share-to-collaborate": "Share to collaborate",
    "add-users-to-collaborate": "Add users to collaborate on the flow",
    "no-shared": "No shared users.",
    "search-user": "Search user...",
    "view-only-mode": "Choose who else can access the flow in view-only mode",
    "share-limitation": "Share with limitation",
    "no-one": "No one",
    "all-members": "All members of the organization",
    "everyone": "Everyone",
    "owner": "owner",
    "editor": "editor",
    "confirm": "Confirm",
    "no-data-available": "No data available",
    "export": "Export",
    "refresh": "Refresh",
    "delete": "Delete",
    "cancel": "Cancel",
    "ok": "OK",
    "create-flow": "Create flow",
    "select-mashup": "Select a mashup",
    "save": "Save",
    "name": "Name",
    "open": "Open",
    "close": "Close",
    "file-input": "File",
    "url": "URL",
    "mashup": {
      "name": "Mashup"
    },
    "import": "Import",
    "import-flow": "Import flow",
    "page-title": "Flows",
    "depencency": "Dependency",
    "type": "Type",
    "conflict": "Conflict",
    "info": "Info",
    "sort-asc": "Ascending creation sort",
    "sort-desc": "Descending creation sort",
    "duplicate": "Duplicate"
  },
  "strings": {
    "delete-flow-question": "Are you sure you want to delete this flow? | Are you sure you want to delete these flows?",
    "unshare-user-tooltip": "Only the owner of the flow can unshare with a user",
    "share-datasources-intro": "The flow contains the following datasources:",
    "confirm-share-datasources-message": "Do you also want to share them with this user?",
    "flow-project-name": "Write a name for your flow",
    "flow-mashup-name": "Choose a mashup for a flow",
    "duplicate-flow-question": "Are you sure you want to duplicate this flow?",
    "flow-status": "The flow status is {status}",
    "no-flows": "This list is empty.",
    "please-add-flows": "Please add a new flow",
    "import-flow-text": "Flow has been successfully imported",
    "import-info": "You can either upload a file from your local device or point to a remote one through its URL.",
    "import-suggest-file": "You can select a file...",
    "import-suggest-url": "...or enter a URL",
    "import-file-format": "Import file format",
    "flow-project-url": "Enter request URL",
    "select-files": "Select your files",
    "import-action-new": "New",
    "import-action-skip": "Keep",
    "import-action-overwrite": "Overwrite",
    "dialog-dependencies-title-conflict": "Dependencies conflict",
    "dialog-dependencies-info-conflict": "There are conflicts with the following dependencies of the flow you are importing. For each dependency, choose whether to add it as New, Keep it as is, or Overwrite it.",
    "dialog-dependencies-no-permission": "no permission",
    "dialog-dependencies-already-released": "already released",
    "dialog-dependencies-version-dependency": "flow version",
    "dialog-dependencies-innerprocess-dependency": "nested flow",
    "dialog-dependencies-endpoint-dependency": "datasource endpoint",
    "dialog-dependencies-custom-operator-dependency": "custom operator",
    "dialog-dependencies-flow-dependency": "flow"
  },
  "errors": {
    "flow-name-required": "A name for your flow project is required!",
    "mashup-select-required": "Mashup for your flow project is required!",
    "flow-import-size": "Import size should be less than 2MB",
    "flow-url-format": "URL format not valid"
  }
}